/* NÛRA / Parrotty — Cinematic Overlay Slideshow (v4)
   v3 still glitched at the loop point on Safari, because it waited for
   Safari's own scrollTo({behavior:'smooth'}) to "settle" — and Safari's
   native smooth-scroll timing is inconsistent (it can pause mid-animation),
   so the clone->real jump sometimes fired before the animation actually
   finished. v4 drives the animation itself with requestAnimationFrame, so
   it knows the exact moment it's done — no browser timing to guess at.
   Manual swipes are untouched: those still use native touch momentum. */

(function () {
  'use strict';

  function initSlideshow(root) {
    var track = root.querySelector('[data-nura-slideshow-track]');
    var realSlides = Array.prototype.slice.call(root.querySelectorAll('[data-nura-slideshow-slide]'));
    var progressLines = Array.prototype.slice.call(root.querySelectorAll('[data-nura-slideshow-goto]'));
    var counterEl = root.querySelector('[data-nura-slideshow-current]');
    var prevBtn = root.querySelector('[data-nura-slideshow-prev]');
    var nextBtn = root.querySelector('[data-nura-slideshow-next]');

    if (!track || realSlides.length === 0) return;

    var realCount = realSlides.length;
    var loop = realCount > 1;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 6000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var isProgrammaticScroll = false;
    var activeAnimation = null;

    var trackIndex = loop ? 1 : 0;

    if (loop) {
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[realCount - 1].cloneNode(true);
      firstClone.setAttribute('data-clone', 'true');
      lastClone.setAttribute('data-clone', 'true');
      firstClone.removeAttribute('id');
      lastClone.removeAttribute('id');
      // Clones must never be lazy — they may be scrolled into view
      // immediately, so force-load their images to avoid a blank flash.
      firstClone.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
      });
      lastClone.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
      });
      track.appendChild(firstClone);
      track.insertBefore(lastClone, realSlides[0]);
    }

    var allSlides = Array.prototype.slice.call(track.children);

    function realIndexFromTrack(idx) {
      if (!loop) return idx;
      return ((idx - 1) % realCount + realCount) % realCount;
    }

    function setActive(realIndex) {
      progressLines.forEach(function (line, i) {
        line.setAttribute('data-active', i === realIndex ? 'true' : 'false');
      });
      if (counterEl) counterEl.textContent = String(realIndex + 1).padStart(2, '0');
    }

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function cancelAnimation() {
      if (activeAnimation) {
        window.cancelAnimationFrame(activeAnimation);
        activeAnimation = null;
      }
    }

    function animateScrollTo(targetLeft, duration, onComplete) {
      cancelAnimation();
      var startLeft = track.scrollLeft;
      var change = targetLeft - startLeft;

      if (change === 0 || reduceMotion) {
        track.scrollLeft = targetLeft;
        if (onComplete) onComplete();
        return;
      }

      var startTime = null;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        track.scrollLeft = startLeft + change * easeInOutQuad(progress);
        if (progress < 1) {
          activeAnimation = window.requestAnimationFrame(step);
        } else {
          track.scrollLeft = targetLeft;
          activeAnimation = null;
          if (onComplete) onComplete();
        }
      }
      activeAnimation = window.requestAnimationFrame(step);
    }

    function normalizeIfOnClone() {
      if (!loop) return;
      if (trackIndex === allSlides.length - 1) {
        trackIndex = 1;
        track.scrollLeft = allSlides[trackIndex].offsetLeft;
      } else if (trackIndex === 0) {
        trackIndex = realCount;
        track.scrollLeft = allSlides[trackIndex].offsetLeft;
      }
    }

function moveTo(idx) {
  if (!allSlides.length) return;

  // Guard against drifting out of bounds if a previous transition was
  // interrupted before it could normalize off a clone (e.g. tab was
  // backgrounded and autoplay's timer outpaced the animation).
  if (idx < 0 || idx >= allSlides.length) {
    trackIndex = loop
      ? (idx >= allSlides.length ? 1 : realCount)
      : Math.max(0, Math.min(trackIndex, allSlides.length - 1));
    track.scrollLeft = allSlides[trackIndex].offsetLeft;
    setActive(realIndexFromTrack(trackIndex));
    isProgrammaticScroll = false;
    return;
  }

  isProgrammaticScroll = true;
  trackIndex = idx;
  var target = allSlides[trackIndex].offsetLeft;
  setActive(realIndexFromTrack(trackIndex));
  animateScrollTo(target, 500, function () {
    normalizeIfOnClone();
    isProgrammaticScroll = false;
  });
}

    function next() { moveTo(trackIndex + 1); }
    function prev() { moveTo(trackIndex - 1); }
    function goTo(realIndex) { moveTo(loop ? realIndex + 1 : realIndex); }

    function startAutoplay() {
      if (!autoplayEnabled || reduceMotion || realCount < 2) return;
      stopAutoplay();
      timer = window.setInterval(next, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); stopAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); stopAutoplay(); });
    progressLines.forEach(function (line) {
      line.addEventListener('click', function () {
        goTo(parseInt(line.dataset.nuraSlideshowGoto, 10));
        stopAutoplay();
      });
    });

    // Manual swipe: native touch momentum, untouched by our animation code.
    // We just watch where it lands and correct for clones after.
    var scrollTimeout = null;
    track.addEventListener('scroll', function () {
      if (isProgrammaticScroll) return;
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(function () {
        var scrollPos = track.scrollLeft;
        var closest = 0;
        var closestDelta = Infinity;
        allSlides.forEach(function (slide, i) {
          var delta = Math.abs(slide.offsetLeft - scrollPos);
          if (delta < closestDelta) {
            closestDelta = delta;
            closest = i;
          }
        });
        trackIndex = closest;
        setActive(realIndexFromTrack(trackIndex));
        normalizeIfOnClone();
      }, 120);
    }, { passive: true });

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, stopAutoplay, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      root.addEventListener(evt, startAutoplay, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAutoplay(); else stopAutoplay();
        });
      }, { threshold: 0.4 });
      observer.observe(root);
    } else {
      startAutoplay();
    }

    window.requestAnimationFrame(function () {
      track.scrollLeft = allSlides[trackIndex].offsetLeft;
      setActive(realIndexFromTrack(trackIndex));
    });
  }

  function init() {
    document.querySelectorAll('[data-nura-slideshow]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-nura-slideshow]');
    if (root) initSlideshow(root);
  });
})();